export const getRouterParams = state => state.app.router.params;
export const getRouterLocation = state => state.app.router.location;
export const getPathRootFromRoute = state => state.app.router.location && state.app.router.location.pathname && state.app.router.location.pathname.split("/")[1];